import React from 'react'

import {
  PopContainer,
  Table,
  Col,
  ActionMenu,
  PopRender,
  Callout,
  Action,
} from '~/components/blueprint'
import {
  Breadcrumb,
  Intent,
  Alert,
  Classes,
  Button,
  Spinner,
} from '@blueprintjs/core'
import service from '~/services/referenceFormatService'
import EditDialog from './EditDialog'
import PropTypes from 'prop-types'

const EDIT_MODE = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  REMOVE: 'REMOVE'
}

const DEFAULT_TYPE = 1 // NONE
const DEFAULT_RESET = 5 // WHEN_RUN_OUT
const DEFAULT_BASE = 10 // 10

const dictFinder = (dict, key) => {
  return rf => {
    let {name} = dict.find(({id})=>id===rf[key]) || {}
    return name
  }
}

class ReferenceNumberFormat extends React.Component {
  constructor(props){
    super(props)
    this.setAction = this.setAction.bind(this)
    this.cleanAction = this.cleanAction.bind(this)
    this.save = this.save.bind(this)
    this.toggle = this.toggle.bind(this)
    this.remove = this.remove.bind(this)
    this.state = {
      loading: false,
      list: [],
      active: null,
      action: null,
      error: null,
      types: [],
      resets: [],
      bases: [],
    }
  }
  componentWillMount(){
    this.fetchList()
  }
  toggle(active){
    this.setState({active})
  }
  async fetchList(){
    this.setState({loading: true})
    try {
      let list = await service.getAll(this.props.params.store_id)
      let dict = await service.getDict(this.props.params.store_id)
      this.setState({ list, ...dict })
    } catch (e) {
      this.setState({ error: e })
    } finally {
      this.setState({ loading: false })
    }
  }
  setAction(target, mode){
    this.setState({
      action: {
        target,
        mode,
      }
    })
  }
  cleanAction(){
    this.setState({action: null, active: null})
  }
  async save(data){
    // await service.modifyAll(this.props.params.store_id, {payment_instruments:[data]})
    if (data.id){
      await service.update(this.props.params.store_id, data)
    } else {
      await service.create(this.props.params.store_id, data)
    }
    this.cleanAction()
    this.fetchList()
  }
  async remove(){
    let {action} = this.state
    let {id} = action.target
    try {
      await service.delete(this.props.params.store_id, id)
      this.cleanAction()
      this.fetchList()
    } catch (e){
      action.error = e
      this.setState({action})
    }
  }
  render(){
    let {active, action, loading, error, list, types, bases, resets} = this.state
    if (loading){
      return (
        <div className="bp pms main-content state-wrapper">
          <Spinner className={Classes.LARGE}/>
        </div>
      )
    }
    if (error){
      return (
        <div className="bp pms main-content state-wrapper">
          <Callout error={error}/>
        </div>
      )
    }

    return (
      <PopContainer className="bp">
        <div className="main-content">
          <ul className="pt-breadcrumbs">
            <li><Breadcrumb disabled text="Home"/></li>
            <li><Breadcrumb disabled text="Settings"/></li>
            <li><Breadcrumb text="Reference Number Format"/></li>
          </ul>
          <Table data={list}>
            <Col field="name" title="Name"/>
            <Col title="Type" render={dictFinder(types, 'type')}/>
            <Col title="Base" render={dictFinder(bases, 'base')}/>
            <Col title="Reset" render={dictFinder(resets, 'reset')}/>
            <Col field="format" title="Format"/>
            <Col style={{width: '10%'}} render={
              (format)=>(
                <ActionMenu
                  active={active}
                  target={format}
                  onToggle={this.toggle}
                  onActionClick={this.setAction}
                >
                  <Action text="Edit" action={EDIT_MODE.EDIT}/>
                  <Action text="Remove" action={EDIT_MODE.REMOVE}/>
                </ActionMenu>
              )
            }/>
          </Table>
          {action?(
            <div>
              <PopRender
                title="New Reference Number"
                isOpen={ action.mode === EDIT_MODE.EDIT || action.mode === EDIT_MODE.ADD }
                onClose={this.cleanAction}
                style={{width: 700}}
              >
                <EditDialog
                  model={ action.target }
                  onSave={ this.save }
                  onCancel={ this.cleanAction }
                  types={types}
                  bases={bases}
                  resets={resets}
                />
              </PopRender>
              <Alert
                isOpen={action.mode===EDIT_MODE.REMOVE}
                cancelButtonText="No"
                confirmButtonText="Yes"
                onConfirm={this.remove}
                onCancel={this.cleanAction}
                iconName="warning-sign"
                intent={Intent.DANGER}
              >
                Are you sure to remove {action.target.name} Reference Number Format?
                <Callout error={action.error}/>
              </Alert>
            </div>
          ):null}
        </div>
        <div className="main-content-header">
          <span className="title">Reference Number Format</span>
          <Button
            text="New Sequence Number"
            iconName="add"
            intent={Intent.PRIMARY}
            onClick={()=>this.setAction({
              type: DEFAULT_TYPE,
              reset: DEFAULT_RESET,
              base: DEFAULT_BASE,
            }, EDIT_MODE.ADD)}
          />
        </div>
      </PopContainer>
    )
  }
}

ReferenceNumberFormat.propTypes = {
  params: PropTypes.object
}

export default ReferenceNumberFormat



/** WEBPACK FOOTER **
 ** ./client/pages/settings/reference-number/index.js
 **/